/* ══════════════════════════════════════════════════════════════
   IPO Live Subscription — Live Subscription Bars
   ══════════════════════════════════════════════════════════════ */

export interface IPOSubscription {
    name: string;
    day: number;
    totalDays: number;
    retail: number;   // times subscribed
    nii: number;
    qib: number;
    total: number;
    closesIn: string;
}

export function renderIPOLiveSubscription(container: HTMLElement, data?: IPOSubscription[]): void {
    const subs: IPOSubscription[] = data || [
        { name: 'Hexaware Technologies', day: 2, totalDays: 3, retail: 3.8, nii: 5.2, qib: 12.5, total: 6.8, closesIn: '1d 4h' },
    ];

    const subCards = subs.map(s => {
        const maxSub = Math.max(s.retail, s.nii, s.qib, 1);
        const barWidth = (v: number) => Math.min(v / maxSub * 100, 100);
        const subColor = (v: number) => v >= 3 ? 'var(--india-green)' : v >= 1 ? 'var(--india-saffron)' : 'var(--india-red)';

        return `
      <div class="ipo-sub-card glass-card">
        <div class="ipo-sub-header">
          <h4>${s.name}</h4>
          <div class="ipo-sub-meta">
            <span>Day ${s.day}/${s.totalDays}</span>
            <span class="closes-badge">⏱️ Closes in ${s.closesIn}</span>
          </div>
        </div>
        <div class="ipo-sub-bars">
          <div class="sub-bar-row">
            <span class="sub-cat">Retail</span>
            <div class="sub-bar-track"><div class="sub-bar-fill" style="width:${barWidth(s.retail)}%;background:${subColor(s.retail)}"></div></div>
            <span class="sub-times" style="color:${subColor(s.retail)}">${s.retail.toFixed(1)}x</span>
          </div>
          <div class="sub-bar-row">
            <span class="sub-cat">NII</span>
            <div class="sub-bar-track"><div class="sub-bar-fill" style="width:${barWidth(s.nii)}%;background:${subColor(s.nii)}"></div></div>
            <span class="sub-times" style="color:${subColor(s.nii)}">${s.nii.toFixed(1)}x</span>
          </div>
          <div class="sub-bar-row">
            <span class="sub-cat">QIB</span>
            <div class="sub-bar-track"><div class="sub-bar-fill" style="width:${barWidth(s.qib)}%;background:${subColor(s.qib)}"></div></div>
            <span class="sub-times" style="color:${subColor(s.qib)}">${s.qib.toFixed(1)}x</span>
          </div>
        </div>
        <div class="ipo-sub-total">
          <span>Total Subscription</span>
          <span class="total-sub" style="color:${subColor(s.total)}">${s.total.toFixed(1)}x</span>
        </div>
      </div>`;
    }).join('');

    container.innerHTML = `
    <div class="ipo-live-sub">
      <div class="card-header"><h3>📊 Live IPO Subscription</h3><span class="live-badge">🔴 LIVE</span></div>
      ${subCards}
    </div>`;
}
